<template>
  <b-card header="Pick Ticket" v-if="show">
    <b-row class="text-center">
      <b-col>
        <vue-barcode :value="order.num">
          Failed to generate
        </vue-barcode>
      </b-col>
    </b-row>
    <b-row>
      <b-table class="text-center" striped sort-by="location" :fields="columns" :items="items">
        <template slot="qty" slot-scope="row">
          {{ row.item.qty }} {{ row.item.uomTag }}
        </template>
      </b-table>
    </b-row>
    <b-alert :show="alert.show" :variant="alert.variant" class="my-1">
      {{ alert.text }}
    </b-alert>
    <b-row>
      <b-col class="text-center">
        <b-btn v-if="isPickable" block variant="info" @click="pickOrder">
          I picked this
        </b-btn>
        <b-btn v-else block variant="warning" disabled>
          Please log in to pick this order.
        </b-btn>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import utility from '../../../helpers/utility'
import { mapGetters } from 'vuex'
import axios from 'axios'
import VueBarcode from 'vue-barcode'
const BASE_API = process.env.VUE_API_ROOT

export default {
  props: {
    order: { type: Object, required: true },
  },
  components: {
    VueBarcode,
  },
  computed: {
    ...mapGetters({
      canAccess: 'canAccess',
      loggedInUser: 'loggedInUser',
      isLoggedIn: 'isLoggedIn',
    }),
    show() {
      return this.order.num.startsWith('TP') && this.order.picks.some(x => x.status.id.fishbowl === 30)
    },
    withinBusinessHours() {
      let hour = new Date().getHours()
      return hour > 7 && hour < 17
    },
    isBusinessDay() {
      let day = new Date().getDay()
      return day > 0 && day < 6
    },
    isPickable() {
      return this.loggedInUser.emails;
    },
  },
  data() {
    return {
      alert: {
        text: undefined,
        show: false,
        variant: undefined,
      },
      columns: {
        partNum: { label: 'Num' },
        location: { sortable: true },
        qty: { label: 'Quantity' },
        partDesc: { label: 'Description' },
      },
      items: [ ],
    };
  },
  mounted() {
    axios.get(`${BASE_API}/fishbowl/pick/S${this.order.num}`).then(response => {
      this.items = response.data
    }).catch(error => {
      console.error(error)
    });
  },
  methods: {
    pickOrder() {
      axios.post(`${BASE_API}/champ/pick-finish/S${this.order.num}`).then(response => {
        utility.waitResponse(response.data, (data) => { // success
          this.infoAuditLog('pick finished', 'I picked this', this.order.num, data, null)
          axios({
            method: 'post',
            headers: { 'Content-Type': 'text/plain' },
            url: `${BASE_API}/notify/picked/${[this.loggedInUser.emails.value, 'ops@andymark.com']}`,
            data: {
              submitter: this.loggedInUser.names.displayName,
              pickNum: `S${this.order.num}`,
            }
          }).then(() => {
            this.setAlert('Pick Finished!', 'success')
          })
        }, (data) => { // failure
          console.error('CHAMP Request Failed!', data.Response)
          this.setAlert('Error: Request to CHAMP Failed! DO NOT RESUBMIT. Contact IT for assistance.', 'danger')
        }, () => { // timeout
          console.error('Request Timed Out!!')
          this.setAlert('Error: Request to CHAMP Timed Out! THIS MAY HAVE GONE THROUGH. Refresh and contact IT if it is still \'pickable\'.', 'warning')
        }, (error) => {
          console.error(error)
          this.setAlert('An unknown error occurred!! CONTACT IT FOR ASSISTANCE.', 'danger')
        })
      }).catch(error => {
        console.error(error);
      });
    },
    setAlert(text, variant) {
      this.alert.text = text
      this.alert.variant = variant
      this.alert.show = true
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sales-order/view-order-2/PickTicket.vue